export interface IPromptDefaults {
  option: string;
  added: boolean;
}

// Suggested Explanation Difficulty Options
export const SUGGESTED_EXPLANATION_DIFFICULTY: IPromptDefaults[] = [
    { option: '<blank>',       added: false },
    { option: 'Technical',     added: false },
    { option: 'Non-Technical', added: false },
    { option: 'Simplified',    added: false }
];

// Suggested Format Options
export const SUGGESTED_FORMATS: IPromptDefaults[] = [
    { option: '<blank>',       added: false },
    { option: 'Plain Text',    added: false },
    { option: 'HTML (no code tags)', added: false },
    { option: 'Bullet points', added: false },
    { option: 'Written Email', added: false }
];

// Suggested Result Length Options
export const SUGGESTED_RESULT_LENGTHS: IPromptDefaults[] = [
    { option: '<blank>',       added: false },
    { option: 'Concise',    added: false },
    { option: '50 words',   added: false },
    { option: '200 words',  added: false },
    { option: '400 words',  added: false },
    { option: '500 words',  added: false },
    { option: '750 words',  added: false },
    { option: '1000 words', added: false }
];

// Suggested Role Options
export const SUGGESTED_ROLES: IPromptDefaults[] = [
    { option: '<blank>',       added: false },
    { option: 'Recruiter',         added: false },
    { option: 'Marketing Manager', added: false }
];

// Suggested Tone Options
export const SUGGESTED_TONES: IPromptDefaults[] = [
    { option: '<blank>',         added: false },
    { option: 'Professional',    added: false },
    { option: 'Salesy',          added: false },
    { option: 'Friendly',        added: false },
    { option: 'Strict and Fair', added: false }
];

// Suggested Languages
export const SUGGESTED_LANGUAGES: IPromptDefaults[] = [
  { option: '<blank>',          added: false },
  { option: 'Arabic',           added: false },
  { option: 'Bulgarian',        added: false },
  { option: 'Cantonese',        added: false },
  { option: 'Chinese',          added: false },
  { option: 'Croatian',         added: false },
  { option: 'Czech',            added: false },
  { option: 'Danish',           added: false },
  { option: 'Dutch',            added: false },
  { option: 'English',          added: false },
  { option: 'English (US)',     added: false },
  { option: 'English (UK)',     added: false },
  { option: 'Estonian',         added: false },
  { option: 'Finnish',          added: false },
  { option: 'Flemish',          added: false },
  { option: 'French',           added: false },
  { option: 'German',           added: false },
  { option: 'Greek',            added: false },
  { option: 'Hindi',            added: false },
  { option: 'Hokkien',          added: false },
  { option: 'Hungarian',        added: false },
  { option: 'Irish',            added: false },
  { option: 'Italian',          added: false },
  { option: 'Japanese',         added: false },
  { option: 'Latvian',          added: false },
  { option: 'Lithuanian',       added: false },
  { option: 'Luxembourgish',    added: false },
  { option: 'Malay',            added: false },
  { option: 'Maltese',          added: false },
  { option: 'Mandarin Chinese', added: false },
  { option: 'Maori',            added: false },
  { option: 'Norwegian',        added: false },
  { option: 'Polish',           added: false },
  { option: 'Portuguese',       added: false },
  { option: 'Punjabi',          added: false },
  { option: 'Romanian',         added: false },
  { option: 'Russian',          added: false },
  { option: 'Samoan',           added: false },
  { option: 'Shanghainese',     added: false },
  { option: 'Slovak',           added: false },
  { option: 'Slovenian',        added: false },
  { option: 'Spanish',          added: false },
  { option: 'Swedish',          added: false },
  { option: 'Tagalog',          added: false },
  { option: 'Tamil',            added: false },
  { option: 'Turkish',          added: false },
  { option: 'Vietnamese',       added: false }
];

// Maximum candidates able to be selected for job submission prompt
export const MAX_SELECTIONS = 20;
